<app-back-to-top></app-back-to-top>
@if (!contactFooter && !loadingContactFooter) {
<div class="footer">
  <app-footer-rebranded></app-footer-rebranded>
</div>
}
@if (contactFooter) {
<div class="-contact-container">
  <div
    class="footer -contact-primary"
    [ngClass]="mode == 'contact' ? '-bottom-offset' : mode == 'contact-no-offset' ? '-no-bottom-offset' : ''">
    <masthead-basic-updated img="/assets/images/hero/value-add-footer.svg">
      <h4>
        {{ contactFooter.title }}
      </h4>
      <p>
        {{ contactFooter.desc }}
      </p>
      <wpbutton class="-medium" [to]="contactFooter.path">{{ contactFooter.button || 'Contact Sales' }}</wpbutton>
    </masthead-basic-updated>
    <div class="footer">
      <app-footer-rebranded></app-footer-rebranded>
    </div>
  </div>
</div>
}
